import React from "react";
import {Box, List, ListItemButton, ListItemText, Popover} from "@mui/material";
import {styled} from "@mui/material/styles";

const MoreButton = styled(ListItemButton)(
	({ theme }) => `
	display: flex;
	align-items: center;
	justify-content: flex-start;
	.MuiSvgIcon-root {
		height: 26px;
		width: 26px;
	}
`
);
const Foobar = ({
	buttons,
	open,
	handleCb,
	handleClose, // <- add this to logic below
	anchorOrigin = {},
	transformOrigin = {},
	listHeaderText = ""
}, ref) => (
	<Popover
		anchorEl={ref?.current}
		onClose={handleClose}
		open={open && buttons.length > 0}
		anchorOrigin={{
			vertical: "bottom",
			horizontal: "right",
			...anchorOrigin
		}}
		transformOrigin={{
			vertical: "top",
			horizontal: "right",
			...transformOrigin
		}}
	>
		<List sx={{p: 1}}>
			{listHeaderText && (
				<ListItemText primary={listHeaderText}/>
			)}
			{buttons.map((option, key) => {
				if (option.visible === false) { return (<Box key={key}/>); }
				if (option.type === "file") {
					return (
						<MoreButton component="label" key={key}>
							{option.icon && option.icon}
							{option.label &&
								<ListItemText sx={{ml: 1.5}} primary={option.label ?? null}/>
							}
							<input
								type="file"
								accept={option.accept}
								onChange={(event) => {
									// console.log("onChange");
									// console.log(event.target.files);
									handleClose();
									option.cb(event.target);
								}}
								style={{display: "none"}}
							/>
						</MoreButton>
					);
				}
				else {
					return (
						<MoreButton
							component="label"
							key={key}
							onClick={() => {
								handleClose();
								option.cb();
							}}
							disabled={option.disabled}
							sx={{...option.sx}}
						>
							{option.icon && option.icon}
							{option.label &&
								<ListItemText sx={{ml: 1.5}} primary={option.label ?? null}/>
							}
						</MoreButton>
					);
				}
			})}
		</List>
	</Popover>
);
const PopoverList = React.forwardRef(Foobar);

export default PopoverList;
